import { Route } from '@angular/router';
import { Path } from '../../common/constants/paths.constant';
import { userStateGuard } from '../../common/guards/userState.guard';
import { buyerRoutes } from './buyer/buyer.routes';
import { supplierRoutes } from './supplier/supplier.routes';
import { contractorRoutes } from './contractor/contractor.routes';

export const dashboardRoutes: Route[] = [
  {
    path: Path.BUYER,
    data: { role: 'buyer' },
    loadComponent: () =>
      import('../../layout/dashboard-layout/dashboard-layout.component').then(
        c => c.DashboardLayoutComponent
      ),
    canActivate: [userStateGuard],
    children: [...buyerRoutes],
  },
  {
    path: Path.SUPPLIER,
    data: { role: 'supplier' },
    loadComponent: () =>
      import('../../layout/dashboard-layout/dashboard-layout.component').then(
        c => c.DashboardLayoutComponent
      ),
    canActivate: [userStateGuard],
    children: [...supplierRoutes],
  },
  {
    path: Path.CONTRACTOR,
    data: { role: 'contractor' },
    loadComponent: () =>
      import('../../layout/dashboard-layout/dashboard-layout.component').then(
        c => c.DashboardLayoutComponent
      ),
    canActivate: [userStateGuard],
    children: [...contractorRoutes],
  },
];
